import { FeatureSwitch } from '@if/core/types'

class FeatureFlags {
  public readonly activateDownloadFCFButton: boolean
  public readonly useIFXFinancingProgram: boolean
  public readonly useFraudFlags: boolean
  public readonly useFraudIQ: boolean
  public readonly useFraudIQPortalScraper: boolean
  public readonly AllowRefusedOverride: boolean
  public readonly fixPersonalLoanVariableTermLoop: boolean
  public readonly useInstantMessage: boolean
  public readonly useFollowUpAgentId: boolean
  public readonly useInstantMessages: boolean
  public readonly usePersonalLoanServiceProviderName: boolean
  public readonly useHighEstimateOnBuyDown: boolean
  public readonly useTaskFollowUpOnPPBKApp: boolean
  public readonly useTaskDashboardGrantedAmount: boolean
  public readonly enableVouchedForThinCreditB2B: boolean
  public readonly useProductChargebackOrRetentionConfig: boolean
  public readonly useIncomeCalculator: boolean
  public readonly useCustomFlashPlan: boolean
  public readonly enableAutoPlus: boolean
  public readonly useProductsSymTechPrime: boolean
  public readonly enableEasyCare: boolean
  public readonly allowProgramAndMerchantChangeOnDraft: boolean

  constructor(featureSwitchDtos: FeatureSwitch[]) {
    const activatedFeatureSwitches = new Set(featureSwitchDtos.filter((x) => x.isActivated).map((x) => x.id))
    this.activateDownloadFCFButton = activatedFeatureSwitches.has('ActivateDownloadFCFButton')
    this.useIFXFinancingProgram = activatedFeatureSwitches.has('UseIFXFinancingProgram')
    this.useFraudFlags = activatedFeatureSwitches.has('UseFraudFlags')
    this.useFraudIQ = activatedFeatureSwitches.has('UseFraudIQ')
    this.useFraudIQPortalScraper = activatedFeatureSwitches.has('UseFraudIQPortalScraper')
    this.AllowRefusedOverride = activatedFeatureSwitches.has('AllowRefusedOverride')
    this.fixPersonalLoanVariableTermLoop = activatedFeatureSwitches.has('FixPersonalLoanVariableTermLoop')
    this.useInstantMessage = activatedFeatureSwitches.has('UseInstantMessage')
    this.useFollowUpAgentId = activatedFeatureSwitches.has('UseFollowUpAgentId')
    this.useInstantMessages = activatedFeatureSwitches.has('UseInstantMessages')
    this.usePersonalLoanServiceProviderName = activatedFeatureSwitches.has('UsePersonalLoanServiceProviderName')
    this.useHighEstimateOnBuyDown = activatedFeatureSwitches.has('UseHighEstimateOnBuyDown')
    this.useTaskFollowUpOnPPBKApp = activatedFeatureSwitches.has('UseTaskFollowUpOnPPBKApp')
    this.useTaskDashboardGrantedAmount = activatedFeatureSwitches.has('UseTaskDashboardGrantedAmount')
    this.enableVouchedForThinCreditB2B = activatedFeatureSwitches.has('EnableVouchedForThinCreditB2B')
    this.useProductChargebackOrRetentionConfig = activatedFeatureSwitches.has('UseProductChargebackOrRetentionConfig')
    this.useIncomeCalculator = activatedFeatureSwitches.has('UseIncomeCalculator')
    this.useCustomFlashPlan = activatedFeatureSwitches.has('UseCustomFlashPlan')
    this.enableAutoPlus = activatedFeatureSwitches.has('EnableAutoPlus')
    this.useProductsSymTechPrime = activatedFeatureSwitches.has('UseProductsSymTechPrime')
    this.enableEasyCare = activatedFeatureSwitches.has('EnableEasyCare')
    this.allowProgramAndMerchantChangeOnDraft = activatedFeatureSwitches.has('AllowProgramAndMerchantChangeOnDraft')
  }
}

export default FeatureFlags
